<template>
    <div class="forgotpasswordlayout">
         <span class="logintext">{{$t('Login.ResetPassword.RESET_PASSWORD_TITLE')}}</span>
         <div class="forgotpasswordform">
             <v-form ref="form" v-model="valid" @keyup.native.enter="valid && send()" onSubmit="return false;" lazy-validation>
                <v-text-field v-model="email" :rules="emailRules" :label="$t('Login.ResetPassword.EMAIL_FIELD_NAME')" :placeholder="$t('Login.ResetPassword.EMAIL_PLACEHOLDER')" required></v-text-field>
                 <p v-if="error" class="errorMessage">{{$t('Login.ResetPassword.INVALID_EMAIL_ERROR')}}</p>
                <br/>
                <v-btn block type="submit"  color="primary" @click="send">{{$t('Login.ResetPassword.SUBMIT_BTN')}}</v-btn>
             </v-form>
         </div>
    </div>
</template>
<script>
import auth from '@/services/Auth'

export default {

  data () {
    return {
      valid: true,
      email: '',
      error: false,
      emailRules: [
        v => !!v || this.$t('Login.ResetPassword.EMAIL_REQUIRED_ERROR'),
        v => /.+@.+/.test(v) || this.$t('Login.ResetPassword.EMAIL_NOT_VALID_ERROR')
      ]
    }
  },
  methods: {
    async send () {
      if (this.$refs.form.validate()) {
        let succeded = false
        if (!this.valid || !this.email) {
          return
        }
        await auth.resetPassword(this.email).then((result) => {
          succeded = result
        }).catch((err) => {
          console.log(err)
          succeded = false
        })
        if (succeded) {
          this.$router.push({ name: 'resetconfirmation', params: { email: this.email } })
        } else {
          this.error = true
        }
      }
    }
  }
}
</script>
<style>
.fullsize {
    width: 100%;
}
</style>
